import { HttpService } from "@/core";
import { BaseResp, UpdaterResp } from "@/core/interface";

export enum MenuTypeEnum {
  MENU = "menu", // 菜单
  PAGE = "page", // 页面
  BUTTON = "button", // 按钮
}

export class MenuRecord extends UpdaterResp {
  id: string = ""; // 菜单 ID
  name: string = ""; // 菜单名称
  type: MenuTypeEnum | "" = ""; // 菜单类型
  parentId: string = ""; // 上级菜单 ID
  path: string = ""; // 菜单路径
  sort: number | undefined = undefined; // 排序值
  remark: string = ""; // 说明
  isRouterMenu: boolean = false; // 是否路由菜单
  isHideRouter: boolean = false; // 是否隐藏路由
  isCacheRouter: boolean = false; // 是否缓存路由
  openMode: boolean = true; // 打开方式, true: 内置; false: 外部
  children:Array<any> = [];
  rightType: number = 0; // Quan
}

export class MenuListResp extends BaseResp {
  records: MenuRecord[] = [];
}

export class MenuService {
  static useFullListApi() {
    const api = (params) =>
      HttpService.backstageAxios({
        method: "GET",
        url: "/menu/list",
        params,
      });
    return HttpService.useRequest<MenuListResp>(api);
  }
}
